// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fwML","question":"styles_question__1W2UO","description":"styles_description__81TFw"};